<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-muted">
              <ul class="block-options">
                  <li v-if="flagDisplayPlanCfg===0">
                      <button type="button" @click="togglePlanDisplay()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayPlanCfg">
                      <button  type="button" @click="togglePlanDisplay()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
              <h2 class="block-title" @click="togglePlanDisplay()">{{ labelFieldTitleBillPlan[actualLanguage] }}</h2>
            </div>

            <div v-if="flagDisplayPlanCfg" class="block-content">
              
              <div class="block-content">
                <div v-if="flagDisplaySelectPlan==true" class="form-group">
                    <label class="col-xs-12 control-label" for="val-select2">{{this.textLabelPreRecordedPlan[this.actualLanguage]}}</label>
                    <div class="col-xs-12">
                      <div class="col-md-6">
                          <select v-model="elecPlanToAddIndex" class="js-select2 form-control" id="val-select2" name="val-select2" style="width: 100%;" data-placeholder="Choose one..">
                              <option value=-1>{{ labelSelectPlan[actualLanguage] }}</option><!-- Required for data-placeholder attribute to work with Select2 plugin -->
                              <option v-for="(plan, index) in electricalPlanDefinitions" v-bind:value=index>{{ plan.planTitle[actualLanguage]}}</option>
                          </select>
                      </div>

                      <div class="col-xs-6 col-md-2">
                          <button @click="addPreRecordedPlan()" class="btn btn-md btn-default" type="button">{{labelApplyButtonBillPlan[actualLanguage]}}</button>
                      </div>

                      <div class="col-xs-6 col-md-2">
                          <button @click="flagDisplaySelectPlan=false" class="btn btn-md btn-danger" type="button">{{labelCancelButtonBillPlan[actualLanguage]}}</button>
                      </div>
                    </div>
                </div>

                <div v-if="flagDisplaySelectPlan==false">
                  <div v-for="(planLine, index) in actualBundle.devices[deviceIndex].DeviceData.deviceInfo.pricingPlan" :key="index">

                    <div v-if="index===0" class="row push">
                      <div class="col-xs-12">
                        
                        <div class="col-xs-12 col-md-4">
                          <h4 class="h3 font-w300 push">{{ labelFieldTitleBasePrice[actualLanguage] }}</h4>
                        </div>
                        <div class="h3 col-xs-12 col-md-4">
                            <div class="h4 form-material">
                                <label for="">{{ labelFieldTitleTarif[actualLanguage] }}</label>
                                <input type="text" class="form-control" v-model="planLine.price">
                            </div>
                        </div>

                      </div>
                    </div>
                    <div v-else class="row push">
                      <div class="col-xs-12"><hr></hr></div>

                      <div class="col-xs-12  items-push">

                        <div class="col-xs-12">

                          <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                              <label class="h3 col-xs-12">Type</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.type" class="h3 form-control" id="example-select" name="example-select" size="1">
                                            <option value=0>{{ labelFieldOptionHoraire[actualLanguage] }}</option>
                                            <option value=1>{{ labelFieldOptionTemperature[actualLanguage] }}</option>
                                  </select>
                              </div>
                            </div>
                          </div>

                          <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label class="h3 col-xs-12" >{{ labelFieldTitleTarif[actualLanguage] }}</label>
                                <div class="col-sm-12">
                                    <input class="h3 form-control" type="text"   v-model="planLine.price">
                                </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="planLine.type==='0'" class="col-xs-12  items-push">

                          <div class="col-xs-12 col-md-4">
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleStartMonth[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.startMonth" class="h3 form-control" size="1">
                                            <option v-for="month in monthOptions" v-bind:value=month.value>{{ month.text }}</option>
                                  </select>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleEndMonth[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.endMonth" class="h3 form-control" size="1">
                                            <option v-for="month in monthOptions" v-bind:value=month.value>{{ month.text }}</option>
                                  </select>
                              </div>
                            </div>
                          </div>

                          <div class="col-xs-12 col-md-4">
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleStartDay[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.startDay" class="h3 form-control" size="1">
                                            <option v-for="day in dayOptions" v-bind:value=day.value>{{ day.text }}</option>
                                  </select>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleEndDay[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.endDay" class="h3 form-control" size="1">
                                            <option v-for="day in dayOptions" v-bind:value=day.value>{{ day.text }}</option>
                                  </select>
                              </div>
                            </div>
                          </div>

                          <div class="col-xs-12 col-md-4">
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleStartHour[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.startHour" class="h3 form-control" size="1">
                                            <option v-for="hour in hourOptions" v-bind:value=hour.value>{{ hour.text }}</option>
                                  </select>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="h3 col-xs-12">{{ labelFieldTitleEndHour[actualLanguage] }}</label>
                              <div class="h3 col-sm-12">
                                  <select v-model="planLine.endHour" class="h3 form-control" size="1">
                                            <option v-for="hour in hourOptions" v-bind:value=hour.value>{{ hour.text }}</option>
                                  </select>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div v-if="planLine.type==='1'" class="col-xs-12">

                          <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                              <label class="col-xs-12" >Condition</label>
                              <div class="col-sm-12">
                                  <select v-model="planLine.tempCondition" class="form-control" size="1">
                                      <option value='0'>{{ labelFieldOptionUnder[actualLanguage] }}</option>
                                      <option value='1'>{{ labelFieldOptionOver[actualLanguage] }}</option>
                                  </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-6">
                            <div class="form-group">
                                <label class="col-xs-12" for="example-text-input2">{{ labelFieldTitleTempThld[actualLanguage] }}</label>
                                <div class="col-sm-12">
                                    <input class="form-control" type="text" id="example-text-input2"  v-model="planLine.tempThreshold">
                                </div>
                            </div>
                          </div>

                        </div>

                        <div class="col-xs-12">
                          
                          <div class="col-xs-12 col-md-12">
                            <div v-if="index > 0" class="col-xs-12">
                              <button type="button" @click="removePlanLine(index)" class="h4 btn btn align-right" name="buttonAddPlanItem"><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelFieldButtonDelete[actualLanguage] }}</button>
                            </div>
                          </div>
                            
                        </div>

                      </div>

                    </div>
                  </div>
                
                  <div class="row ">
                    <div class="form-group">
                      <div class="col-xs-12 items-push">
                        <div class="col-xs-12 col-md-6">
                          <button type="button" @click="addPlanLine" class="h4 btn btn-block btn-success" name="buttonAddPlanItem"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelFieldButtonAddCond[actualLanguage] }}</button>
                        </div>

                        
                        <div class="col-xs-12 col-md-6">
                            <button @click="selectPreRecordedPlan()" class="h4 btn btn-block btn-success align-right" type="button">{{labelSelectPreRecBillPlan[actualLanguage]}}</button>
                        </div>
                        


                      </div>
                    </div>
                  </div>


                  <div class="row ">
                    <div class="form-group">
                      
                      <div class="col-xs-12 items-push">

                        <label class="h4 col-xs-12" for="example-text-input2">{{ labelCopyPlanFromAnotherModule[actualLanguage] }}</label>

                        <div class="h4 col-xs-12 col-md-6">
                          <button type="button" @click="copyPlanFromAnothermodule" class="h4 btn btn-block btn-success" name="buttonAddPlanItem"><i class="fa fa-copy fa-1x push-5-r "></i>{{labelButtonCopyPlanFromModule[actualLanguage]}}</button>
                        </div>

                        <div class="col-xs-12 col-md-6">
                          <div class="form-group">
                            <div class="col-sm-12">
                                <select v-model="moduleIndexToCopyPlan" class="h4 form-control" size="1">
                                          <option v-for="(device,index) in actualBundle.devices" v-bind:value=index>{{ device.ReferenceName }}</option>
                                </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row ">
                    
                      <div class="col-xs-12 items-push">
                        <label class="h3 col-xs-12" for="example-text-input2">{{ labelApplyActualPlanToOtherModule[actualLanguage] }}</label>
                        <div class=" col-xs-12 col-md-12">
                          <button type="button" @click="applyThisPlanToAll" class="h4 btn btn-block btn-success" name="buttonAddPlanItem">{{ labelFieldButtonApplyPlanAllDevice[actualLanguage] }}</button>
                        </div>
                      </div>
                    
                  </div>


                </div>

              </div>


              <div class="block-content">
                
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import electPlanDef from '@/views/configuration/ElectricalPlanDefinition.js'

export default {
  props: ['deviceIndex'],
  data() {
    return {
      flagDisplayDevice : 0,
      electricalPlanDefinitions : electPlanDef,
      elecPlanToAddIndex : 0,
      
      actualLanguage : "FR",
      flagDisplaySelectPlan : false,
      flagDisplayPlanCfg : 0,

      moduleIndexToCopyPlan : 0,

      monthOptions:[{text:'01-Jan', value:1},{text:'02-Fév/Feb', value:2},{text:'03-Mar', value:3},
                    {text:'04-Avr/Apr', value:4},{text:'05-Mai/May', value:5},{text:'06-Jui/Jun', value:6},
                    {text:'07-Jui/Jul', value:7},{text:'08-Aoû/Aug', value:8},{text:'09-Sept', value:9},
                    {text:'10-Oct', value:10},{text:'11-Nov', value:11},{text:'12-Déc/Dec', value:12}],

      dayOptions:[{text:'Lun/Mon', value:1},{text:'Mar/Tue', value:2},{text:'Mer/Wed', value:3},
                    {text:'Jeu/Thu', value:4},{text:'Ven/Fri', value:5},{text:'Sam/Sat', value:6},
                    {text:'Dim/Sun', value:7}],

      hourOptions:[{text:'00:00', value:0},{text:'01:00', value:1},{text:'02:00', value:2},{text:'03:00', value:3},{text:'04:00', value:4},
                  {text:'05:00', value:5},{text:'06:00', value:6},{text:'07:00', value:7},{text:'08:00', value:8},{text:'09:00', value:9},
                  {text:'10:00', value:10},{text:'11:00', value:11},{text:'12:00', value:12},{text:'13:00', value:13},{text:'14:00', value:14},
                  {text:'15:00', value:15},{text:'16:00', value:16},{text:'17:00', value:17},{text:'18:00', value:18},{text:'19:00', value:19},
                  {text:'20:00', value:20},{text:'21:00', value:21},{text:'22:00', value:22},{text:'23:00', value:23},{text:'24:00', value:24}],


      labelFieldTitleBillPlan: {FR: 'Plan de tarification électrique', EN: 'Electrical billing plan'},
      labelApplyButtonBillPlan: {FR: 'Appliquer', EN: 'Apply'},
      labelCancelButtonBillPlan: {FR: 'Annuler', EN: 'Cancel'},
      labelSelectPreRecBillPlan: {FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan'},
      labelSelectPlan: {FR: 'Sélectionner un plan', EN: 'Select plan'},
      labelFieldTitleBasePrice: {FR: 'Tarif de base:', EN: 'Base price:'},
      labelFieldTitleTarif: {FR: 'Tarif ($/kWh)', EN: 'Price ($/kWh)'},
      labelFieldOptionHoraire: {FR: 'Horaire', EN: 'Scheduled'},
      labelFieldOptionTemperature: {FR: 'Température', EN: 'Temperature'},
      labelFieldTitleStartMonth: {FR: 'Mois début', EN: 'Start month'},
      labelFieldTitleEndMonth: {FR: 'Mois fin', EN: 'End month'},
      labelFieldTitleStartDay: {FR: 'Jour début', EN: 'Start day'},
      labelFieldTitleEndDay: {FR: 'Jour fin', EN: 'End day'},
      labelFieldTitleStartHour: {FR: 'Heure début', EN: 'Start hour'},
      labelFieldTitleEndHour: {FR: 'Heure fin', EN: 'End hour'},
      labelFieldOptionUnder: {FR: 'Inférieur à:', EN: 'Under:'},
      labelFieldOptionOver: {FR: 'Supérieur à:', EN: 'Over:'},
      labelFieldTitleTempThld: {FR: 'Température seuil (C)', EN: 'Threshold température (C)'},
      labelFieldButtonDelete: {FR: 'Supprimer cette condition', EN: 'Delete this contition'},

      labelButtonCopyPlanFromModule : {FR: 'Copier le plan du module:', EN: 'Copy plan from module:'},
      labelFieldButtonApplyPlanAllDevice : {FR: 'Appliquer ce plan à tous les modules de ce Système', EN: 'Apply this plan to all module of this Systems'},
      labelFieldButtonAddCond: {FR: 'Ajouter une condition au plan', EN: 'Add billing plan condition'},
      labelField: {FR: '', EN: ''},
      labelFieldButtonSave: {FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters'},
    
      textLabelPreRecordedPlan:{FR: "Plan pré-enregistré", EN: 'Pre recorded plan'},
      labelCopyPlanFromAnotherModule:{FR: "Copier le plan d'un module du système, sélectionner le module dont vous voulez copier le plan et appuyez sur le bouton.", EN: "Copy plan from another module of the system, select the module that you want to copy it's plan and press the button"},
      labelApplyActualPlanToOtherModule:{FR: "Appliquer ce plan du module actuel aux autres modules du système", EN: "Apply the plan of this module to all other system's modules"},
      messageConfirmApplyPlanToOtherDevice:{FR: "Confirmer l'application de ce plan aux autres Modules de ce Système!", EN: 'Confirm billing plan change for all Module in this Systems!'},
      messageConfirmApplyPlanToOtherDeviceSave:{FR: "Vous devez Sauvegarder les paramètres de chaque module pour officialiser le changement de plan.", EN: 'You must Save the module parameters for each module to confirm plan modifications.'},

      messageConfirmPlanChangeA:{FR: "Confirmer le changement de plan de tarification pour :", EN: 'Confirm billing plan change for : '},
      messageConfirmPlanChangeB:{FR: ". Cette action est irréversible!", EN: '. This operation is not reversible!'},
      messageMustSaveDevice:{FR: "Vous devez Sauvegarder les paramètres du module pour confirmer l'enregistrement.", EN: 'You must save the module parameters to record modifications.'},


    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
  },
  watch: {

  },

  methods: {
  

    togglePlanDisplay(){
      this.flagDisplayPlanCfg = ~this.flagDisplayPlanCfg
    },

    addPlanLine(){
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan.push({type:'0',tempCondition:'0',tempThreshold:-14,startMonth:1,endMonth:12,startDay:1,endDay:7,startHour:0,endHour:24,price:0.092})
      //this.flagSaveModule = true
    },
    removePlanLine(index){
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan.splice(index,1)
      //this.flagSaveModule = true
    },
    applyThisPlanToAll(){
        var ActualPlan = JSON.parse(JSON.stringify(this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan))

        if (window.confirm(this.messageConfirmApplyPlanToOtherDevice[this.actualLanguage])){
              for(var n=0;n<this.actualBundle.devices.length;n++){this.actualBundle.devices[n].DeviceData.deviceInfo.pricingPlan = ActualPlan}
              window.alert(this.messageConfirmApplyPlanToOtherDeviceSave[this.actualLanguage])

            }

    },

    selectPreRecordedPlan(){
      var requestData = { 'postAction':'GetPreRecordedPlan',
                          'planList':'Electrical_Pricing_Plan::'+process.env.FRONT_END_VERSION}
                          //console.log(requestData)
      this.$store.dispatch('sessionStore/postElectricalPlan', requestData)
          .then((response) => {
            //console.log(response)
          if(response.data.Code=='OK'){
            //console.log('PLAN READ')
              this.electricalPlanDefinitions = response.data.PlansDefinitions
              //console.log(this.electricalPlanDefinitions)
              this.flagDisplaySelectPlan=true
              }
          })
    },

    addPreRecordedPlan(){
      if(this.elecPlanToAddIndex >= 0){
          var ActualPlanTitle = this.electricalPlanDefinitions[this.elecPlanToAddIndex].planTitle[this.actualLanguage]

          if (window.confirm(this.messageConfirmPlanChangeA[this.actualLanguage] + ActualPlanTitle + this.messageConfirmPlanChangeB[this.actualLanguage])){
            this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.electricalPlanDefinitions[this.elecPlanToAddIndex].plan
            window.alert(this.messageMustSaveDevice[this.actualLanguage])
            this.flagDisplaySelectPlan = false
            //this.save()
          }
      }
    },


    copyPlanFromAnothermodule(){
      //console.log(this.moduleIndexToCopyPlan)
      this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = JSON.parse(JSON.stringify(this.actualBundle.devices[this.moduleIndexToCopyPlan].DeviceData.deviceInfo.pricingPlan))

      window.alert(this.messageMustSaveDevice[this.actualLanguage])
    },


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;


    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },



}
</script>

<style lang="css">

  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 16px;}
  .h5 {font-size: 12px;}
  table thead th.h5 {font-size: 14px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
      table thead th.h5 {font-size: 10px;}
  }

</style>



// WEBPACK FOOTER //
// ConfigDevicePlan.vue?399085c8